import React, { Fragment } from "react";
/** @jsxImportSource @emotion/react */
import { Avatar, Badge, Divider } from "antd";
import tw, { styled } from "twin.macro";
import MainLayout from "../../components/MainLayout/MainLayout";
import { hideScrollbar, LandingTitle } from "../../lib/styles/styleLibrary";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import { useQuery } from "react-query";
import { EmptyData, PageLoading } from "../../components";
import { isEmpty } from "../../lib/helpers/helpers";
import { fetchNotifications } from "../../redux/actions/notifications";
import dayjs from "dayjs";
import { v4 } from "uuid";

const Wrapper = styled.div`
	${tw`p-4 h-full pb-0 relative`}
`;

const Notifications = (props) => {
	var relativeTime = require("dayjs/plugin/relativeTime");
	dayjs.extend(relativeTime);
	const history = useHistory();
	// const [page, setPage] = useState(1);
	const page = 1;
	const { data: notifications, isLoading } = useQuery(
		["Notifications", page],
		() => fetchNotifications({ page }),
		{
			keepPreviousData: true,
		}
	);

	// console.log(notifications);
	return (
		<MainLayout tw="relative">
			<Wrapper>
				<div tw="flex flex-row flex-nowrap items-center justify-between">
					<div
						tw="inline-flex flex-nowrap items-center gap-2 hover:cursor-pointer"
						onClick={() => {
							history.goBack();
						}}>
						<ArrowLeftOutlined tw="px-3 py-3 bg-gray-100 rounded-full hover:bg-white" />
						<LandingTitle tw="text-lg! font-bold leading-8 m-0">
							Notifications
						</LandingTitle>
					</div>
					<Badge count={notifications?.unread_count} />
				</div>

				<div
					tw="mt-4 mb-4! w-full h-full overflow-y-auto"
					css={hideScrollbar}>
					{isLoading ? (
						<PageLoading />
					) : isEmpty(notifications?.all_notifications) ? (
						<div tw="h-full w-full flex items-center justify-center">
							<EmptyData
								description={
									"No notifications yet your latest alerts will appear here as soon as you have one"
								}
							/>
						</div>
					) : (
						<div tw=" w-full h-full">
							{notifications?.notifications_grouped_by_day.map(
								(notification) => {
									return (
										<Fragment key={v4()}>
											<div tw="mb-4 font-bold">
												{dayjs(notification.day).format(
													"ddd, DD MMMM YYYY"
												)}
											</div>
											<div tw="pl-4">
												{notification.notifications.map(
													(notify, i) => {
														return (
															<Fragment
																key={v4()}>
																<div
																	tw="w-full flex flex-row gap-4 flex-nowrap"
																	key={i}>
																	<div>
																		<Avatar
																			src={
																				"https://miro.medium.com/max/600/1*PiHoomzwh9Plr9_GA26JcA.png"
																			}
																			style={{
																				backgroundColor:
																					"#D7D7E3",
																			}}
																			tw="rounded-full"
																			size={
																				50
																			}
																		/>
																	</div>
																	<div tw="flex flex-col justify-between w-full">
																		<div tw="flex flex-row justify-between items-center">
																			<h4 tw="font-bold m-0!">
																				{
																					notify.title
																				}
																			</h4>
																			<span>
																				{dayjs(
																					notify.createdAt
																				).fromNow()}
																			</span>
																		</div>
																		<div>
																			{
																				notify.message
																			}
																		</div>
																	</div>
																</div>
																<Divider tw="mt-4 mb-4" />
															</Fragment>
														);
													}
												)}
											</div>
										</Fragment>
									);
								}
							)}
						</div>
					)}
				</div>
			</Wrapper>
		</MainLayout>
	);
};

export default Notifications;
